export default __webpack_public_path__ + "images/MK.fb2ae53.png";